import styled from "styled-components";
import { Edit2, Info, Trash, X } from "react-feather";
import { darken } from "polished";

export const Container = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.text};

  span {
    display: block;
    line-height: 1.3;

    &:first-child {
      font-weight: bold;
    }
  }
`;

export const Infos = styled.div``;

export const EditIcon = styled(Edit2)`
  cursor: pointer;

  &:hover {
    stroke: ${props => props.theme.colors.muted};
  }
`;

export const TrashIcon = styled(Trash)`
  cursor: pointer;

  &:hover {
    stroke: ${props => darken(0.1, props.theme.colors.danger)};
  }
`;

export const UserName = styled.div`
  display: flex;
  align-items: center;
  gap: .5rem;
`;

export const RealEstateButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: .25rem;
  border: 0;
  border-radius: .25rem;
  background: ${props => props.theme.colors.accent};
  color: ${props => props.theme.colors.highlightedText};
  padding: .125rem .4rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: opacity .2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const UserPhone = styled.div`
  display: flex;
  align-items: center;
  gap: .5rem;
  font-size: 0.8rem;
`;

export const PausedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: .25rem;
  background: ${props => props.theme.colors.danger};
  color: ${props => props.theme.colors.highlightedText};
  padding: .125rem .4rem;
  font-size: 0.75rem;
  font-weight: bold;
`;

export const InfoIcon = styled(Info)`
  cursor: pointer;

  &:hover {
    stroke: ${props => props.theme.colors.muted};
  }
`;

export const XIcon = styled(X)`
  right: .5rem;
`;
